<template>
  <div class="statement-react">
    <add-button @toggleOn="addCommentStatement()" />
  </div>
</template>

<script>
  import StatementCommentAdd from "./StatementCommentAdd.ts";

  export default StatementCommentAdd;
</script>
